import React from "react";
import PropTypes from "prop-types";

const Item = ({ children }) => {
  const gridClass = "m-three-column-grid";

  return (
    <div className={`${gridClass}__item ${gridClass}__item--1`}>{children}</div>
  );
};

Item.propTypes = {
  children: PropTypes.node,
};

export default Item;
